export type CareVariant = 'coach' | 'clinic';

type VisitCopy = {
  duration: string;
  /** Used where the existing copy spells out "minutes". */
  minutes: number;
  /** The line under the visit title. Names the provider type, which on the
   * coach plan is the only place this screen says there is no doctor visit. */
  providerLine: string;
  whatHappens: string;
  whatDoIGet: { intro: string; includedLabel: string; included: string[] };
};

const SHARED_INTRO =
  'Ayble offers comprehensive virtual support for your digestive health ' +
  'journey. Built by experts at Mayo Clinic and Cleveland Clinic, Ayble ' +
  'builds a personalized plan to help you find relief from IBS, GERD, IBD, ' +
  'or everyday bloating and pain.';

export const VISIT_COPY: Record<CareVariant, VisitCopy> = {
  clinic: {
    duration: '45 mins',
    minutes: 45,
    providerLine:
      'Your doctor will listen, understand your history & goals, and help you ' +
      'make a digestive symptom relief plan.',
    whatHappens:
      'You will spend 45 minutes with a doctor who will listen, understand ' +
      'your history & goals, and make a digestive symptom relief plan.',
    whatDoIGet: {
      intro: SHARED_INTRO,
      includedLabel: "What's included:",
      included: [
        '1:1 virtual care from doctors, dietitians, and health coaches.',
        'Personalized nutrition coaching and food trigger tracking.',
        'Guided relaxations and medication advice.',
        'Grocery tools and barcode scanners for easy shopping.',
      ],
    },
  },
  coach: {
    duration: '30 mins',
    minutes: 30,
    providerLine:
      'Your coach will listen, understand your history & goals, and help you ' +
      'make a digestive symptom relief plan.',
    whatHappens:
      'You will spend 30 min with a coach who will listen, understand your ' +
      'history & goals, and make a digestive symptom relief plan.',
    whatDoIGet: {
      intro: SHARED_INTRO,
      includedLabel: "What's included:",
      included: [
        '1:1 virtual care from a digestive health coach.',
        'Personalized nutrition coaching and food trigger tracking.',
        'Guided relaxations and stress tools to reduce flare ups.',
        'Symptom tracking in the app to see your improvement over time.',
        '24/7 messaging.',
        'Grocery tools and barcode scanners for easy shopping.',
      ],
    },
  },
};

export const COMMON_QUESTIONS_LABEL = 'Common questions';

export const QUESTIONS = {
  whatDoIGet: 'What do I get with Ayble?',
  cost: 'What will this cost?',
  whatHappens: 'What happens in this visit?',
  reschedule: 'Can I reschedule?',
};

export const RESCHEDULE_ANSWER =
  'Yes, at no charge, as long as you do it at least 48 hours before your ' +
  "visit. There's a reschedule link in your confirmation.";

export const STRIPE_COST_ANSWER = {
  lead: 'Monthly Membership: $83.99 / month total',
  paragraphs: ['Cancel anytime, no commitment'],
};

export const DEFAULT_COST_ANSWER = {
  paragraphs: [
    'Ayble is a medical practice covered by most insurance. Most Ayble ' +
      'patients pay **$0-$30** for their first and follow-up visits.',
    "You'll typically pay the same out-of-pocket cost as you would for any " +
      'other in-network doctor. It will vary by health plan and individual, ' +
      'depending on factors such as remaining deductible balance. Patients ' +
      'with high-deductible plans may pay more upfront until their deductible ' +
      'has been met.',
    'If you want us to check your estimated cost of care, email us at ' +
      '**support@ayblehealth.com**',
  ],
};
